import "./Navbar.css";
import logo from "../../assets/logo.png";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";

function Navbar() {
  return (
    <>
      <div className="topbar">
        <div className="container">
          <div className="topbar-content">

            <div>
              <FaPhoneAlt className="me-2" />
              +91 7722000088
            </div>

            <div>
              <FaEnvelope className="me-2" />
              info@potech.in
            </div>

          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">

        <div className="container">

          <a className="navbar-brand d-flex align-items-center" href="/">

            <img
              src={logo}
              alt="Potech Technologies"
              className="logo"
            />

          </a>

          <button
            className="navbar-toggler"
            data-bs-toggle="collapse"
            data-bs-target="#menu"
          >
            ☰
          </button>

          <div className="collapse navbar-collapse" id="menu">

            <ul className="navbar-nav ms-auto align-items-lg-center">

              <li className="nav-item">
                <a href="/" className="nav-link active">
                  Home
                </a>
              </li>

              <li className="nav-item">
                <a href="#about" className="nav-link">
                  About
                </a>
              </li>

              <li className="nav-item">
                <a href="#services" className="nav-link">
                  Services
                </a>
              </li>

              <li className="nav-item">
                <a href="#portfolio" className="nav-link">
                  Portfolio
                </a>
              </li>

              <li className="nav-item">
                <a href="#contact" className="nav-link">
                  Contact
                </a>
              </li>

              <li className="nav-item ms-lg-3">

                <a
                  href="https://wa.me/917722000088"
                  className="btn btn-primary px-4"
                >
                  Get Quote
                </a>

              </li>

            </ul>

          </div>

        </div>

      </nav>
    </>
  );
}

export default Navbar;